import { Box } from "@mui/material";
import { Link } from "react-router-dom";
import type { ChatCitation } from "../types";

// deep_link is an absolute app URL ("/app/<space>/<id>"). The router basename is
// "app", so strip a leading "/app" to avoid a doubled "/app/app/..." path.
const toRouterPath = (deepLink: string) => deepLink.replace(/^\/app(?=\/)/, "");

const TEAL = "#0a9ca2";

/** A single source rendered as a compact chip: doc icon + truncated title, links to the article. */
const CitationChip: React.FC<{ citation: ChatCitation }> = ({ citation }) => (
  <Box
    component={Link}
    to={toRouterPath(citation.deep_link)}
    title={citation.title || citation.page_id}
    sx={{
      display: "inline-flex",
      alignItems: "center",
      gap: "6px",
      maxWidth: "100%",
      px: "10px",
      py: "8px",
      bgcolor: "#f4f6f7",
      border: "1px solid #e6eaec",
      borderRadius: "10px",
      textDecoration: "none",
      transition: "all .15s ease",
      "&:hover": { borderColor: TEAL, bgcolor: "#f0fafa" },
    }}
  >
    <svg
      aria-hidden
      width={14}
      height={14}
      viewBox="0 0 24 24"
      fill="none"
      stroke={TEAL}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ flexShrink: 0 }}
    >
      <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" />
      <path d="M14 3v5h5" />
    </svg>
    <Box
      component="span"
      sx={{
        fontSize: "13px",
        fontWeight: 600,
        color: "#172127",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      }}
    >
      {citation.title || citation.page_id}
    </Box>
  </Box>
);

export default CitationChip;
